import { create } from 'zustand';

/**
 * Caso 07 — Lightweight UI store for the AI assistant drawer. Holds nothing
 * but the open/close state. The conversation itself lives in
 * `aiAssistantStore.ts` (fingerprint + messages); keeping the UI store
 * separate avoids spurious re-renders when the chat thread updates.
 */
interface AssistantUiState {
  open: boolean;
  setOpen: (v: boolean) => void;
  toggle: () => void;
}

export const useAssistantUi = create<AssistantUiState>((set) => ({
  open: false,
  setOpen: (v) => set({ open: v }),
  toggle: () => set((s) => ({ open: !s.open })),
}));
